import '@vuepic/vue-datepicker/dist/main.css'
import './assets/styles/main.css'
import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { useUserStore } from '@/stores/user'
import { createAxiosInstance } from '@/api/apiClient'
import { VueQueryPlugin } from '@tanstack/vue-query'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { i18n } from '@/i18n'

const { MODE } = import.meta.env

const app = createApp(App)
const pinia = createPinia()

if (window.location.hostname !== 'localhost') {
  Bugsnag.start({
    apiKey: 'b2543a9c7cb464c735780e945ddca60d',
    plugins: [new BugsnagPluginVue()],
    releaseStage: MODE,
  })
  BugsnagPerformance.start({ apiKey: 'b2543a9c7cb464c735780e945ddca60d' })
  const bugsnagVue = Bugsnag.getPlugin('vue')

  if (!bugsnagVue) throw new Error('Bugsnag plugin not found')
  app.use(bugsnagVue)
}

pinia.use(piniaPluginPersistedstate)

app.use(i18n)
app.use(VueQueryPlugin)
app.use(pinia)
app.use(router)
createAxiosInstance()

function setupYandexMetrika() {
  if (MODE !== 'production') return

  const checkReady = setInterval(() => {
    const ym = (window as any).ym
    if (typeof ym === 'function') {
      clearInterval(checkReady)
      console.log('Yandex Metrika ready for tracking')

      const userStore = useUserStore()

      if (userStore.user) {
        ym(102171601, 'params', { user_id: userStore.user.id })
      }

      watch(
        () => userStore.user,
        (user) => {
          ym(102171601, 'params', { user_id: user?.id })
        },
        { immediate: false },
      )

      router.afterEach((to) => {
        ym(102171601, 'hit', to.fullPath)
      })
    }
  }, 300)

  // Безопасная остановка, если ym не появился
  setTimeout(() => clearInterval(checkReady), 10000)
}

setupYandexMetrika()

app.mount('#app')
